
      (function() {
        const s = document.createElement('script');
        s.src = 'https://www.google.com/recaptcha/api.js?render=6Le6FtoqAAAAAC1V4imly-XZkqNlljmUwjj6B8va';
        s.type = 'text/javascript';
        s.async = true;
        s.defer = true;
        document.body.appendChild(s);
      })();
    